export const DONATION_PRODUCT_TYPE = 'donation';
